// errors
export const ERROR_FAILED_GET_TESTS = 'failed to load jobs';
export const ERROR_FAILED_LOAD_METRICS = 'failed to load job metrics';
export const ERROR_FAILED_LOAD_ORGANIZATION = 'failed to load organization';
export const ERROR_FAILED_LOAD_ERRORS = 'failed to load aggregated errors';
export const ERROR_FAILED_LOAD_AGGREGATED_TEST_NAMES = 'failed to load aggregated job names';
export const ERROR_FAILED_LOAD_TEST_TRENDS = 'failed to load job trends';
export const ERROR_FAILED_LOAD_PAST_TRENDS = 'failed to load past trends';
